import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { addressString } from '@core/util/address';
import { Address } from '@models/address';
import { Company } from '@models/company';
import { CreateOrUpdateLawFirmModel } from '../create/create.component';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { ActivatedRoute } from '@angular/router';
import { LawFirmEmployeeType } from '@models/lawFirms';
import { openClose } from '@core/animations/animations';
import { GlobalDataManagementRequestDispatch } from 'src/app/global-data-management/state/global-data-management/global-data-management.request.dispatch';
import { TestHooks } from './law-firms-side-form.hooks';
import { Select } from '@ngxs/store';
import { MatterFieldMappings } from '@models/matter';
import { Observable } from 'rxjs';
import { SkeletonLoaderType } from 'src/app/ui/skeleton-loader/skeleton-loader.component';
import { LawFirm } from '@models/lawFirms';

@Component({
	selector: 'app-law-firms-side-form',
	templateUrl: './law-firms-side-form.component.html',
	animations: [openClose(300)],
	standalone: false,
})
export class LawFirmsSideFormComponent {
	testHooks = TestHooks;
	@Output() onFocus = new EventEmitter<string>();
	@Input() label = '';
	@Input() collapsed = false;
	@Input() showClerk = false;
	@Input() placeholder = '';
	@Input() lawFirm: LawFirm;
	@Input() skeletonLoading = false;

	public lawFirmModel: CreateOrUpdateLawFirmModel;
	public lawFirmName = '';
	public ICON = ICON;
	public hoverShadow = true;
	public showCreateForm = false;
	public skeletonLoadingFirmType = SkeletonLoaderType.FIRM_CARD;

	@SelectSnapshot(SelectedMatter.id) saleId;
	@ViewSelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SelectedMatter.getFieldMappings)
	fieldMappings$: Observable<MatterFieldMappings>;

	constructor(
		private matterDispatch: MatterDispatch,
		private navigationService: NavigationService,
		private globalStoreDispatch: GlobalDataManagementRequestDispatch,
		private route: ActivatedRoute,
	) {}

	lawFirmDropdownOptionSelect(event) {
		switch (event.result.name) {
			case 'Edit':
				this.updateLawFirm();
				break;
			case 'Remove':
				this.removeLawFirm();
				break;
		}
	}

	setAddress(address: Address): string {
		return addressString(address);
	}

	_onCreate(event: Company) {
		this.showCreateForm = false;
		this.matterDispatch.CreateLawFirm(this.saleId, event);
		this.globalStoreDispatch.RequestLawFirmChange(event);
	}

	_onCancel() {
		this.showCreateForm = false;
	}

	//Lawfirm actions

	selectLawFirm = (ev) =>
		this.matterDispatch.SelectLawFirm(this.saleId, ev.id, ev.leap);
	removeLawFirm = () => this.matterDispatch.RemoveLawFirm(this.saleId);

	createLawFirm(event) {
		if (event) {
			this.showCreateForm = true;
			this.lawFirmName = event.name;
		}
	}

	updateLawFirm() {
		this.lawFirmModel = { name: this.lawFirm.name, lawFirm: this.lawFirm };
		this.navigationService.goToUrl('edit-law-firm', null, {
			relativeTo: this.route,
			state: { lawFirm: this.lawFirm },
		});
	}

	// Lawyer actions

	selectLawyer = (ev) =>
		this.matterDispatch.SelectLawFirmEmployee(
			this.saleId,
			ev.lawFirmId,
			ev.id,
			LawFirmEmployeeType.LAWYER,
			ev.leap?.personId,
		);
	removeLawyer = () =>
		this.matterDispatch.RemoveLawFirmEmployee(
			this.saleId,
			LawFirmEmployeeType.LAWYER,
		);
}
